<ng-container>
  <div *ngIf="type === productSelectorConstant?.ACCESSORIES">
    <h4 class="m-t-xl">{{ aemContent?.accessories }}</h4>
  </div>

  <div *ngIf="type === productSelectorConstant?.DEVICES && nonLineItemsList?.length > 0">
    <h4 class="m-t-xl">{{ aemContent?.standaloneDevices }}</h4>
  </div>

  <p *ngIf="nonLineItemsList?.length > 0" class="lead bold m-t-lg">{{ addedCountDescription }}</p>
  <div *ngIf="nonLineItemsList?.length > 0">
    <div class="row m-t-md" *ngFor="let product of nonLineItemsList; let idx = index">
      <ng-container *ngIf="product.selectedDevice">
        <div class="col-6" *ngIf="idx < maxLimit">
          <p>
            {{ product?.selectedDevice?.familyName }} {{ product?.selectedDevice?.color }}
            {{ product?.selectedDevice?.memory }}
          </p>
        </div>
        <div class="col-6 col-md-5 text-end" *ngIf="idx < maxLimit">
          <p>{{ aemContent?.quantity }} {{ product?.quantity }}</p>
        </div>
      </ng-container>
    </div>

    <div *ngIf="nonLineItemsList?.length > defaultMaxLimit">
      <p *ngIf="!seeAll">
        <a href="javascript:void(0)" (click)="showAll()" id="cta-default-140">{{
          aemContent?.seeMore
        }}</a>
      </p>
      <p *ngIf="seeAll" class="m-t-md">
        <a href="javascript:void(0)" (click)="showAll()" id="cta-default-141">{{
          aemContent?.seeLess
        }}</a>
      </p>
    </div>
  </div>
</ng-container>
